<template>
  <div class="date-range-input">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input type='hidden' name="{{ field.name }}" class="form-control" v-model="field.value"/>
        <div class="row">
          <div class="col-sm-4">
            <select class="form-control" v-model="day">
              <option value="" disabled>Select a Day</option>
              <template v-for="n in daysInMonth">
                <option v-bind:value="n+1">{{ n + 1 }}</option>
              </template>
            </select>
          </div>
          <div class="col-sm-4">
            <select class="form-control" v-model="month" v-on:change="">
              <option value="" disabled>Select a Month</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>
          <div class="col-sm-4">
            <input type='text' name="" class="form-control" v-model="year" placeholder="YYYY" v-on:change=""/>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <select class="form-control" v-model="hour">
              <option value="1">01</option>
              <option value="2">02</option>
              <option value="3">03</option>
              <option value="4">04</option>
              <option value="5">05</option>
              <option value="6">06</option>
              <option value="7">07</option>
              <option value="8">08</option>
              <option value="9">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="0" selected>12</option>
            </select>
          </div>
          <div class="col-sm-4">
            <select class="form-control" v-model="minute">
              <option value="0" selected>00</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="45">45</option>
            </select>
          </div>
          <div class="col-sm-4">
            <select class="form-control" v-model="meridiem">
              <option value="am" selected>AM</option>
              <option value="pm">PM</option>
            </select>
          </div>
        </div>
        <span class="form-validation-error" v-show="!field.valid && field.dirty && !field.valid">Date entered is not valid.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success form-control-feedback-select" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error form-control-feedback-select" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form-control {
  margin:5px
}
</style>

<script>
import moment from 'moment-timezone'
export default {
  name: 'DateTimeInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          type: 'date-time',
          value: ''
        }
      }
    }
  },
  computed: {
    daysInMonth: function () {
      return moment(`${this.year}-${this.month}`, 'YYYY-MM').daysInMonth()
    },
    day: {
      get: function () {
        return moment(this.field.value).date()
      },
      set: function (val) {
        val = parseInt(val)
        this.field.value = moment(this.field.value).set('date', val)
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate) && this.field.value.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = this.field.value.isBefore(this.field.maxDate)
        }
      }
    },
    month: {
      get: function () {
        return moment(this.field.value).month() + 1
      },
      set: function (val) {
        val = parseInt(val)
        this.field.value = moment(this.field.value).set('month', (val - 1))
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate) && this.field.value.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = this.field.value.isBefore(this.field.maxDate)
        }
      }
    },
    year: {
      get: function () {
        return moment(this.field.value).year()
      },
      set: function (val) {
        val = parseInt(val)
        this.field.value = moment(this.field.value).set('year', val)
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate) && this.field.value.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = this.field.value.isBefore(this.field.maxDate)
        }
      }
    },
    hour: {
      get: function () {
        let hour = moment(this.field.value).hour()
        if (hour > 12) hour -= 12
        return hour
      },
      set: function (val) {
        val = parseInt(val)
        if (moment(this.field.value).format('a') === 'pm') val += 12
        this.field.value = moment(this.field.value).set('hour', val)
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate) && this.field.value.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = this.field.value.isBefore(this.field.maxDate)
        }
      }
    },
    minute: {
      get: function () {
        return (((moment(this.field.value).minute() + 7.5) / 15 | 0) * 15) % 60
      },
      set: function (val) {
        val = parseInt(val)
        this.field.value = moment(this.field.value).set('minute', val)
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate) && this.field.value.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = this.field.value.isBefore(this.field.maxDate)
        }
      }
    },
    meridiem: {
      get: function () {
        return moment(this.field.value).format('a')
      },
      set: function (val) {
        if (val === 'pm') this.field.value = moment(this.field.value).add(12, 'h')
        if (val === 'am') this.field.value = moment(this.field.value).subtract(12, 'h')
        if (this.field.minDate && this.field.maxDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate) && this.field.value.isBefore(this.field.maxDate)
        } else if (this.field.minDate) {
          this.field.valid = this.field.value.isAfter(this.field.minDate)
        } else if (this.field.maxDate) {
          this.field.valid = this.field.value.isBefore(this.field.maxDate)
        }
      }
    }
  },
  methods: {
    validateField (val) {
      if (val) {
        this.field.dirty = true
        if (this.field.required) {
          if (val.day !== '' && val.month !== '' && val.year !== '' && val.hour !== '' && val.minute !== '' && val.meridiem !== '') {
            let m = moment(`${val.day}/${val.month}/${val.year} ${val.hour}:${val.minute} ${val.meridiem}`, 'D/M/Y h:m a')
            this.field.value = m.format('D/M/Y hh:mm a')
            this.field.valid = this.field.value !== 'Invalid date'
            if (this.field.minDate && this.field.maxDate) {
              this.field.valid = m.isAfter(this.field.minDate) && m.isBefore(this.field.maxDate)
            } else if (this.field.minDate) {
              this.field.valid = m.isAfter(this.field.minDate)
            } else if (this.field.maxDate) {
              this.field.valid = m.isBefore(this.field.maxDate)
            }
          } else {
            this.field.valid = false
          }
        } else {
          this.field.valid = true
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DateTimeInput.vue?2b111560